import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { inquireBonusCode, InquireBonusCodeRequest, InquireBonusCodeResponse } from "./code.api";
import { InquireBonusCodeErrorMessages } from "./code.error";

export const inquireBonusCodeThunk = createAsyncThunk(
  "Code/InquireBonusCode",
  async (request: InquireBonusCodeRequest, { rejectWithValue }) => {
    const { response, error } = await inquireBonusCode(request);
    if (error) {
      toast.info(InquireBonusCodeErrorMessages[error]);
      return rejectWithValue(error);
    }
    return response as InquireBonusCodeResponse;
  }
);
